import { Offerte } from "../model/offerte";
import { Soglie } from "../model/soglie";

export class Irenled12 {
  public static  offerta ():Offerte {
      return {
		Flg_Indicizzato: false,
        Id_Offerta: 115,
        Id_Foritore: 1,
        Id_comodity: 4,
        TipoContratto:1,
        NomeOfferta: "KIT LED 12",
        LinkFoto: "./assets/images/offerte-iren/kit-led-12.jpg",
        LinkFotoLarge: "./assets/images/offerte-iren/kit-led-12.jpg",
        LinkFotoMid: "./assets/images/offerte-iren/kit-led-12.jpg",
        LinkFotoSm: "./assets/images/offerte-iren/kit-led-12.jpg",
        LinkFotoCarousel: "./assets/images/offerte-iren/kit-led-12.jpg",
        DescrizioneCarousel: "Che Offerta super",
        DescrizioneNomeOfferta: "Operare una politica di risparmio energetico, anche a casa, è una scelta importante sia dal punto di vista economico che ambientale. Un valido aiuto in questo senso è il kit di lampadine Iren Led, che potrai pagare in piccole rate addebitate direttamente in bolletta.",
        PromozioneOfferta: "",
        Sezioni: [
          {
            NomeSezione: "RISPARMIO ASSICURATO",
            DescrizioneSezione: "Iren Kit Led da 12 lampadine,  composto da:",
            lstPunti: ["4 LED goccia 60W attacco E27","4 LED goccia 40W attacco E27","4 LED oliva 40W attacco E14"]
          },
          {
            NomeSezione: "Perché preferire le lampade Led a quelle a incandescenza?",
            DescrizioneSezione: "Negli ultimi anni si sta assistendo a una sempre maggiore diffusione delle lampadine Led. Ci troviamo di fronte infatti a un prodotto che permette un consistente risparmio economico e di energia elettrica, con una comprovata resistenza e durata.",
            lstPunti: ["L.e.d. sta per Light Emitting Diode, ovvero diodo a emissione luminosa. In parole più semplici si parla di lampade che non utilizzano più al loro interno i tradizionali filamenti a incandescenza, ma una nuova generazione di semiconduttori che sfruttano l'illuminazione allo stato solido. Ciò consente una vita utile e un'efficienza ben superiori rispetto a quelle delle ottenute con lampadine a incandescenza."
            ]

          },
          {
            NomeSezione: "Il risparmio di consumi con le lampadine LED",
            DescrizioneSezione: "Molti consumatori vengono scoraggiati nell'uso di questa tecnologia dal costo un po' più elevato di queste lampade rispetto a quelle tradizionali. In realtà, essa permette un notevole risparmio economico che si concretizza nel medio e lungo periodo. Infatti, le lampade Led hanno durata media che varia dalle 50mila alle 80mila ore, mentre la vita delle vecchie lampadine a incandescenza è di sole circa mille ore. Considerando che la differenza di costo nell'acquisto dei nuovi prodotti è solo lievemente superiore, il calcolo è presto fatto. Inoltre non bisogna dimenticare la maggiore efficienza energetica: le lampadine Led usano e disperdono molta meno energia elettrica, a differenza di quelle a incandescenza trasformano in luce solo il 10% dell'energia assorbita.",
            lstPunti: [
            ]

          }
        ],
        PrezzoEle: 0.,
        PrezzoGas: 0,
       
        TitoloPlus: "RISPARMIO ASSICURATO",
        Plus: ["4 LED goccia 60W attacco E27","4 LED goccia 40W attacco E27","4 LED oliva 40W attacco E14"]
        ,schedaconfrontabilitaele:
        {
          tabellaConfrontabilita:[]
        }
        ,schedaconfrontabilitagas:
        {
          tabellaConfrontabilita:[]
        }
        ,lstModalitaPagamento :["1","2"]
        ,scontoRid:0 
        ,TipoSoglieEle: Soglie.SoglieEle4Fasce()
        ,ImportoAnnuoLordo: 0
        ,ImportoAnnuoNetto: 0
        ,ImportoMensileLordo: 0
        ,ImportoMensileNetto: 0
        ,iscopertura: "" 
      };
    }
}



// WEBPACK FOOTER //
// ./src/app/archivioofferte/irenled12.ts